<template>
  <div>
    <el-row class="search-add" :gutter="10">
      <el-col :span="6">
        <el-input placeholder="设备编号" v-model="deviceId"></el-input>
      </el-col>
      <el-col :span="18">
        <el-button type="primary" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </el-col>
    </el-row>

    <el-table :data="data" border stripe style="width: 100%">
      <el-table-column prop="deviceId" label="设备编号"> </el-table-column>
      <el-table-column
        prop="protPrefix"
        :label="'prot_prefix/帧头'"
        :render-header="renderheader"
      >
      </el-table-column>
      <el-table-column
        prop="cmdType"
        :label="'cmd_type/数据类型'"
        :render-header="renderheader"
      >
      </el-table-column>
      <el-table-column
        prop="iatUploadDefault"
        :label="'at_upload_default/默认变频时间间隔(分钟)'"
        :render-header="renderheader"
      >
      </el-table-column>
      <el-table-column
        prop="iatUpload"
        :label="'iat_upload/变频时间间隔(分钟）'"
        :render-header="renderheader"
      >
      </el-table-column>
      <el-table-column
        prop="isGps"
        :label="'is_gps/是否开启GPS'"
        :render-header="renderheader"
      >
      </el-table-column>
      <el-table-column
        prop="isGsensor"
        :label="'is_gsensor/是否开启G-sensor开关'"
        :render-header="renderheader"
      >
      </el-table-column>
      <el-table-column
        prop="isGsensorWakeup"
        :label="'is_gsensor_wakeup/是否触发G-sensor唤醒上报'"
        :render-header="renderheader"
      >
      </el-table-column>
      <el-table-column
        prop="gsensitivityLevel"
        :label="'g_sensitivity_level/G-Sensor移动敏感程度'"
        :render-header="renderheader"
      >
      </el-table-column>
      <el-table-column
        prop="gduration"
        :label="'g_duration/G-Sensor加速度持续时间(毫秒）'"
        :render-header="renderheader"
      >
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="onEdit(scope.row)">
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="tableDel-Page">
      <Pagination :params="pagin" @pageBind="getList"></Pagination>
    </div>
    <el-dialog title="" :visible.sync="open" @close="closeDailog">
      <el-form
        :model="rule"
        ref="rule"
        class="demo-ruleForm"
        label-width="180px"
      >
        <el-form-item label="起始设备编号" prop="deviceId">
          <el-col :span="20">
            <el-input
              placeholder="请输入起始设备编号"
              v-model="rule.deviceId"
              disabled
            ></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="变频时间间隔" prop="iatUpload">
          <el-col :span="20">
            <el-input
              placeholder="请输入变频时间间隔"
              v-model="rule.iatUpload"
              clearable
            ></el-input>
          </el-col>
          <el-col :span="4"> 分钟 </el-col>
        </el-form-item>
        <el-form-item label="触发G-Sensor唤醒上报" prop="isGsensorWakeup">
          <el-radio-group v-model="rule.isGsensorWakeup">
            <el-radio label="1">触发上报</el-radio>
            <el-radio label="0">禁止上报</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="开启GPS" prop="isGps">
          <el-radio-group v-model="rule.isGps">
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">不开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="G-Sensor移动敏感程度" prop="gsensitivityLevel">
          <el-col :span="20">
            <el-input-number
              v-model="rule.gsensitivityLevel"
              :min="1"
              :max="127"
              label="请输入G-Sensor移动敏感程度"
              :style="{ width: '100%' }"
            ></el-input-number>
          </el-col>
        </el-form-item>
        <el-form-item label="G-Sensor加速度持续时间(毫秒)" prop="gduration">
          <el-col :span="20">
            <el-input-number
              v-model="rule.gduration"
              :min="1"
              :max="127"
              label="请输入G-Sensor加速度持续时间(毫秒)"
              :style="{ width: '100%' }"
            ></el-input-number>
          </el-col>
          <el-col :span="4"> *40 </el-col>
        </el-form-item>
        <el-form-item label="开启G-sensor" prop="isGsensor">
          <el-radio-group v-model="rule.isGsensor">
            <el-radio label="1">开启</el-radio>
            <el-radio label="0">不开启</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDailog">取 消</el-button>
        <el-button type="primary" @click="Save">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
export default {
  name: "admin",
  data() {
    return {
      env: this.getEnv(),
      deviceId: "",
      open: false,
      data: [],
      rowData: {},
      pagin: {
        pageNum: 1,
        pageSize: 20,
        total: 0,
      },
      rule: {
        deviceId: "",
        iatUpload: "",
        isGsensorWakeup: "",
        isGps: "",
        gsensitivityLevel: "",
        gduration: "",
        isGsensor: "",
      },
    };
  },
  methods: {
    search() {
      //搜索
      this.pagin.pageNum = 1;
      this.getList();
    },
    getList() {
      //数据绑定
      let params = {
        pageNum: this.pagin.pageNum,
        pageSize: this.pagin.pageSize,
      };
      if (this.deviceId.trim() != "") {
        params.deviceId = this.deviceId;
      }
      this.$http
        .post(`${this.env}/manage/device-mqtt-downlink/list/`, params)
        .then((results) => {
          this.data = results["data"]["data"]["records"];
          this.pagin.total = results["data"]["data"]["total"];
        });
    },
    Save() {
      this.$http
        .post(
          `${this.env}/manage/device-mqtt-downlink/addDownlinkInfo`,
          this.rule
        )
        .then((rs) => {
          if (rs.data.code == 0) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.open = 0;
          } else {
            this.$message({
              message: rs.data.message,
              type: "error",
            });
          }
        });
    },
    onEdit(data) {
      this.open = true;
      this.rule = data;
    },
    closeDailog() {
      this.open = false;
    },
    renderheader(h, { column }) {
      return h("span", {}, [
        h("span", {}, column.label.split("/")[0]),
        h("br"),
        h("span", {}, column.label.split("/")[1]),
      ]);
    },
    getEnv() {
      if (location.host == "localhost:8080") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "dev.iotmanage.baitengfa.com") {
        return "https://dev.iotmanage.baitengfa.com";
      } else if (location.host == "iotmanage.baitengfa.com") {
        return "https://iotmanage.baitengfa.com";
      }
    },
  },
  components: { Pagination },
};
</script>

<style scoped>
.search-add {
  margin-bottom: 10px;
}
</style>